// @flow
import { APICore } from './apiCore';

const api = new APICore();

// account
function ApiGetAllKategoriMenu(params: any): any {
    const baseUrl = '/api/admin/kategorimenu';
    return api.get(`${baseUrl}`, params);
}
function ApiGetAllMenu(params: any): any {
    const baseUrl = '/api/admin/menu';
    return api.get(`${baseUrl}`, params);
}
function ApiPostCategoryMenu(params: any): any {
    const baseUrl = '/api/admin/kategorimenu';
    return api.create(`${baseUrl}`, params);
}
function ApiPostMenu(params: any): any {
    const baseUrl = 'api/admin/menu';
    return api.create(`${baseUrl}`, params);
}
function ApiEditKategoriMenu(params: any, id: any): any {
    const baseUrl = '/api/admin/kategorimenu/' + id;
    return api.update(`${baseUrl}`, params);
}
function ApiEditMenu(params: any, id: any): any {
    const baseUrl = 'api/admin/menu/' + id;
    console.log('🚀 ~ ApiEditMenu ~ id:', id);
    return api.update(`${baseUrl}`, params);
}
// function ApiDeleteKategoriRoom(params: any, id: any): any {
//     const baseUrl = '/api/admin/kategoriroom/' + id;
//     return api.delete(`${baseUrl}`, params);
// }

export { ApiGetAllKategoriMenu, ApiGetAllMenu, ApiEditKategoriMenu, ApiPostCategoryMenu, ApiPostMenu, ApiEditMenu };
